module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-43.fd65b1e4.jpg";